var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 73,
    viewBox: "0 0 77 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.9375 13.6875C52.9375 6.12801 46.4737 0 38.5 0C30.5263 0 24.0625 6.12801 24.0625 13.6875C24.0625 21.247 30.5263 27.375 38.5 27.375C46.4737 27.375 52.9375 21.247 52.9375 13.6875ZM35.1297 34.3756C26.2071 29.1971 11.7545 27.7742 4.48164 27.3821C2.03779 27.251 0 29.0161 0 31.2446V63.011C0 65.0541 1.74303 66.7579 3.98385 66.8677C10.5499 67.1942 23.8339 68.3904 33.0153 72.7747C34.4244 73.4477 36.0953 72.5309 36.0953 71.0823V36.0095C36.0938 35.3437 35.7463 34.7335 35.1297 34.3756ZM72.5184 27.3821C65.247 27.7728 50.7929 29.1971 41.8718 34.3756C41.2552 34.7335 40.9078 35.3679 40.9078 36.0338V71.078C40.9078 72.5309 42.5831 73.4491 43.9968 72.7747C53.1766 68.3947 66.4531 67.1985 73.0177 66.872C75.2585 66.7608 77.0015 65.057 77.0015 63.0138V31.2446C77 29.0161 74.9622 27.251 72.5184 27.3821Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M52.9375 13.6875C52.9375 6.12801 46.4737 0 38.5 0C30.5263 0 24.0625 6.12801 24.0625 13.6875C24.0625 21.247 30.5263 27.375 38.5 27.375C46.4737 27.375 52.9375 21.247 52.9375 13.6875ZM35.1297 34.3756C26.2071 29.1971 11.7545 27.7742 4.48164 27.3821C2.03779 27.251 0 29.0161 0 31.2446V63.011C0 65.0541 1.74303 66.7579 3.98385 66.8677C10.5499 67.1942 23.8339 68.3904 33.0153 72.7747C34.4244 73.4477 36.0953 72.5309 36.0953 71.0823V36.0095C36.0938 35.3437 35.7463 34.7335 35.1297 34.3756ZM72.5184 27.3821C65.247 27.7728 50.7929 29.1971 41.8718 34.3756C41.2552 34.7335 40.9078 35.3679 40.9078 36.0338V71.078C40.9078 72.5309 42.5831 73.4491 43.9968 72.7747C53.1766 68.3947 66.4531 67.1985 73.0177 66.872C75.2585 66.7608 77.0015 65.057 77.0015 63.0138V31.2446C77 29.0161 74.9622 27.251 72.5184 27.3821Z",
    fill: "white",
    stroke: "url(#paint0_linear)",
    strokeWidth: 6,
    mask: "url(#path-1-inside-1)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 6.85393e-7,
    y1: 11.5,
    x2: 116,
    y2: 98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD8061"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395136,
    stopColor: "#FD8061",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.846924,
    stopColor: "#FD8061",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.06e5a2f8.svg";
export { ForwardRef as ReactComponent };